<app-info-navigation-tree [items]="navigationItems" (itemClick)="onItemClick($event)"></app-info-navigation-tree>
<app-info-content [html]="content()"></app-info-content>